// extracted by mini-css-extract-plugin
export default {"productGallery":"eH-z","inQuickShop":"fH-z"};